import React, { useState, useEffect } from 'react';
import { getZipFile } from '../Services/MarketingMaterial.service';
import { translate } from '../Services/translation';

const MarketingMaterial = ({ categories, channelId }) => {
  categories = JSON.parse(categories);
  const [buttonText, setButtonText] = useState(
    translate('marketingmaterial.download')
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [downloadImages, setDownloadImages] = useState(false);
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [hasTooManyCategories, setHasTooManyCategories] = useState(false);
  useEffect(() => {
    if (downloadImages && checkedCategories.length > 2) {
      setHasTooManyCategories(true);
    } else {
      setHasTooManyCategories(false);
    }
  }, [downloadImages, checkedCategories]);
  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (formIsNotValid()) {
      return;
    }
    setButtonText(translate('marketingmaterial.generatingzipfile'));
    setButtonDisabled(true);
    try {
      await getZipFile(checkedCategories, channelId, downloadImages);
      setButtonText(translate('marketingmaterial.download'));
      setButtonDisabled(false);
    } catch (e) {
      setButtonText(translate('marketingmaterial.download'));
      setButtonDisabled(false);
    }
  };
  const formIsNotValid = () => {
    return (
      checkedCategories.length == 0 ||
      (checkedCategories.length > 2 && downloadImages)
    );
  };
  const onToggleCheckbox = (value) => {
    let categories;
    if (checkedCategories.some((x) => x == value)) {
      categories = [...checkedCategories.filter((x) => x != value)];
    } else {
      categories = [...checkedCategories, value];
    }
    setCheckedCategories(categories);
  };
  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="columns">
          <div>
            <h2>{translate('marketingmaterial.downloadheader')}</h2>
            {categories.map((x) => (
              <div key={x.id}>
                <input
                  type="checkbox"
                  name="categoryIds"
                  value={x.id}
                  onChange={() => onToggleCheckbox(x.id)}
                  id={x.id}
                />
                <label htmlFor={x.id} className="marketing-material__label">
                  {x.name}
                </label>
              </div>
            ))}
            {hasTooManyCategories && (
              <p className="marketing-material__error">
                {translate('marketingmaterial.toomanycategories')}
              </p>
            )}
            <div className="marketing-material__download-images">
              <input
                name="downloadimages"
                type="checkbox"
                id="downloadImages"
                checked={downloadImages}
                onChange={() => setDownloadImages(!downloadImages)}
              />
              <label
                htmlFor="downloadImages"
                className="marketing-material__label"
              >
                {translate('marketingmaterial.downloadimages')}
              </label>
            </div>
            <input name="channelid" value={channelId} type="hidden" />

            {buttonDisabled && (
              <div className="loading--wrapper">
                <div className="loading-circle"></div>
              </div>
            )}

            <button
              type="submit"
              className="marketing-material__button"
              disabled={buttonDisabled}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default MarketingMaterial;
